import { FullProject } from 'entities';

import { Filters } from 'components/ListManipulation';

import { KanbanView } from './KanbanView';
import { ProjectList } from './ActiveProjectList';
import { ProjectsTable } from './TableView';

interface ActiveProjectsProps {
  children?: never;
  view: string;
  projects: FullProject[];
  filters: Filters;
  loading?: boolean;
}

const views = {
  cards: ProjectList,
  table: ProjectsTable,
  kanban: KanbanView,
};

export function ActiveProjects({ filters, projects, view, loading }: ActiveProjectsProps) {
  const Component = views[view as keyof typeof views];

  return <Component projects={projects} filters={filters} loading={loading} />;
}
